module.exports = __webpack_public_path__ + "static/media/lockIcon.dc18ede0.svg";